// components/public/publicRoutes.js
import {
  INDEXABLE_PUBLIC_ROUTES,
  LEGAL_PUBLIC_ROUTES,
  PUBLIC_SERVER_RENDERED_ROUTES,
  PUBLIC_UTILITY_ROUTES,
  getPublicPageDefinition,
  normalizePublicRegistryPath,
} from './publicSiteRegistry.mjs';

export const INDEXABLE_MARKETING_ROUTES = INDEXABLE_PUBLIC_ROUTES;
export { LEGAL_PUBLIC_ROUTES, PUBLIC_SERVER_RENDERED_ROUTES, PUBLIC_UTILITY_ROUTES };

export const PUBLIC_MARKETING_ROUTES = Object.freeze([
  ...INDEXABLE_MARKETING_ROUTES,
  ...LEGAL_PUBLIC_ROUTES,
]);

const INDEXABLE_ROUTE_SET = new Set(INDEXABLE_MARKETING_ROUTES);
const MARKETING_ROUTE_SET = new Set(PUBLIC_MARKETING_ROUTES);
const UTILITY_ROUTE_SET = new Set(PUBLIC_UTILITY_ROUTES);

export function normalizePublicPath(pathname = '/') {
  return normalizePublicRegistryPath(pathname);
}

export function isKnownMarketingPath(pathname = '/') {
  return MARKETING_ROUTE_SET.has(normalizePublicPath(pathname));
}

export function isMarketingNamespacePath(pathname = '/') {
  const normalized = normalizePublicPath(pathname);
  return (
    normalized === '/services' ||
    normalized.startsWith('/services/') ||
    normalized === '/platform' ||
    normalized.startsWith('/platform/') ||
    normalized === '/projects' ||
    normalized.startsWith('/projects/') ||
    normalized === '/about' ||
    normalized.startsWith('/about/') ||
    normalized === '/contact' ||
    normalized.startsWith('/contact/') ||
    normalized === '/privacy-policy' ||
    normalized.startsWith('/privacy-policy/') ||
    normalized === '/terms-of-service' ||
    normalized.startsWith('/terms-of-service/')
  );
}

export function isMarketingPath(pathname = '/') {
  const normalized = normalizePublicPath(pathname);
  return isKnownMarketingPath(normalized) || isMarketingNamespacePath(normalized);
}

export function isIndexableMarketingPath(pathname = '/') {
  return INDEXABLE_ROUTE_SET.has(normalizePublicPath(pathname));
}

export function isPubliclyAccessiblePath(pathname = '/') {
  const normalized = normalizePublicPath(pathname);
  return isMarketingPath(normalized) || UTILITY_ROUTE_SET.has(normalized);
}

export function shouldIncludeCanonical(pathname = '/') {
  const normalized = normalizePublicPath(pathname);
  return Boolean(getPublicPageDefinition(normalized));
}

export function dashboardPathForUser(user) {
  const role = String(user?.usertype || user?.userType || '').toLowerCase().trim();
  return role === 'general manager' ? '/ums/general-manager-dashboard' : '/dashboard';
}


